import axios, { AxiosResponse } from 'axios';

import { IApiListParams, IOrderApiListResponse } from '@/types';

export const loadOrder = (params: IApiListParams): Promise<AxiosResponse<IOrderApiListResponse>> => {
    return axios.get('/api/order/list', { params });
};

export const createOrder = (data: { rows: Record<string, any>[] }) => {
    return axios.post('/api/order/create', data);
};

export const updateOrder = (id: number, statusId: number) => {
    return axios.post('/api/order/update', { rows: [{ id: id, status_id: statusId }] });
};
